module.exports = __webpack_public_path__ + "static/media/back-olive.39e51c71.png";